import { render, staticRenderFns } from "./PgaValutazioneOffertaAltriPresaleDetails.vue?vue&type=template&id=371a106c&"
import script from "./PgaValutazioneOffertaAltriPresaleDetails.vue?vue&type=script&lang=ts&"
export * from "./PgaValutazioneOffertaAltriPresaleDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardTitle,VDataTable,VForm,VSpacer,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('371a106c')) {
      api.createRecord('371a106c', component.options)
    } else {
      api.reload('371a106c', component.options)
    }
    module.hot.accept("./PgaValutazioneOffertaAltriPresaleDetails.vue?vue&type=template&id=371a106c&", function () {
      api.rerender('371a106c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/ValutazioneOfferta/Components/PgaValutazioneOffertaAltriPresaleDetails.vue"
export default component.exports